"use client";

import styled from "styled-components";

interface BoxProps {
  $column?: boolean;
  $align?: "start" | "center" | "end" | "stretch" | "baseline";
  $justify?: "start" | "center" | "end" | "between" | "around" | "evenly";
  $gap?: string;
  $fullWidth?: boolean;
  $fullHeight?: boolean;
  $mb?: string;
}

export const Box = styled.div<BoxProps>`
  display: flex;
  flex-direction: ${({ $column }) => ($column ? "column" : "row")};
  margin-bottom: ${({ $mb }) => ($mb ? $mb : `0`)};

  ${({ $fullWidth }) =>
    $fullWidth == true ? "width: 100%;" : "width: fit-content;"}
  ${({ $fullHeight }) =>
    $fullHeight == true ? "height: 100%;" : "height: fit-content;"}

${({ $align }) =>
    $align &&
    `align-items: ${$align === "start" ? "flex-start" : $align === "end" ? "flex-end" : $align};`}
${({ $justify }) =>
    $justify &&
    `justify-content: ${
      $justify === "start"
        ? "flex-start"
        : $justify === "end"
          ? "flex-end"
          : $justify === "between"
            ? "space-between"
            : $justify === "around"
              ? "space-around"
              : $justify === "evenly"
                ? "space-evenly"
                : $justify
    };`}

  gap: ${({ $gap }) => $gap && $gap}
`;
